import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
import {
  blueColour,
  defaultFontItalic,
  defaultFontNormal,
} from "../utils/styling";

export const getPoaParagraphs = (data) => {
  const { formattedPoAStart, formattedPoAEnd, groupName, ultimateParentName } =
    data;

  const paragraphs = [
    {
      segments: [
        {
          text: "The period for which an Interest Restriction Return must be prepared is based on the period of account of the worldwide group. In general, the period of account of a worldwide group is:",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "The period for which the ultimate parent draws up (consolidated or single entity) accounts, if it is the ultimate parent throughout that period (ss480-482 & s484 TIOPA 2010);",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "The period for which it is the ultimate parent, if it draws up consolidated financial statements but is only the ultimate parent for part of the period (s483 TIOPA 2010); or",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Where there is an “accounts free” period, the period determined by s485 TIOPA 2010. This is typically a period of up to 12 months during which none of s480-484 TIOPA 2010 apply but throughout which a worldwide group exists.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "An election can be made under s486 TIOPA 2010 to alter the default period (and for example align it with the majority of the companies in the group). Where the ultimate parent only draws up individual entity accounts it is also possible to elect under s484(3) that there is an accounts free period of the ultimate parent.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "Application to the ",
          font: defaultFontItalic,
          break: 1,
        },
        {
          text: groupName,
          font: defaultFontItalic,
        },
        {
          text: " group",
          font: defaultFontItalic,
        },
      ],
    },
    {
      segments: [
        {
          text: "The period of account of the ",
          font: defaultFontNormal,
        },
        {
          text: groupName,
          font: defaultFontItalic,
        },
        {
          text: " group is from ",
          font: defaultFontNormal,
        },
        {
          text: formattedPoAStart,
          font: defaultFontNormal,
        },
        {
          text: " to ",
          font: defaultFontNormal,
        },
        {
          text: formattedPoAEnd,
          font: defaultFontNormal,
        },
        {
          text: ". This is on the basis that ",
          font: defaultFontNormal,
        },
        {
          text: "[Relationship team to insert short summary of the basis where this does not fit into the first bullet above. Where the first bullet above applies, the next alternative can generally be used] / [",
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: ultimateParentName,
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: " draws up [consolidated] / [single entity] accounts for the period from ",
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: formattedPoAStart,
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: " to ",
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: formattedPoAEnd,
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: ".]",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Period of Account"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
